<g id="g-{{id}}" pointer-events="bounding-box">
<rect class="{{type}}-value value-box" id="box-{{type}}-{{id}}" x="{{minX}}" y="{{minY}}" width="{{width}}" height="8" />
<text class="value-text" id="{{type}}-{{id}}" x="{{MATH minX '+' deltaX}}" y="{{MATH minY '+' 5}}" alignment-baseline="middle" text-anchor="middle" />
</g>
